var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail"},[_c('img',{staticClass:"thumbnail__img",attrs:{"height":"50","width":"50","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }